import React, { useState } from 'react'
import {
  Div,
} from 'konsys-ui'
import {
  ContentParts,
  FullWidthContainer,
  SummaryDiv,
} from './styled'
import TabPart from '../../../../../components/common/tab-part'
import PriceCalculationForm from '../price-calculator-form'
import Summary from '../summary'

const Parts = ({
  data,
  setFormValues,
  formValues,
  onChangeTab,
  activeTab,
  isMobileXL,
  disabled,
  setDisabled,
  ContentRef,
}) => (
  <FullWidthContainer>
    <ContentParts>
      <TabPart
        onChange={onChangeTab}
        data={data.packageParts && data.packageParts}
        isMobileXL={isMobileXL}
        keyTab={activeTab}
      >
        <Div display='flex' alignItems='center' justifyContent='center'>
          { data.packageParts && <Div flexBasis={isMobileXL ? '100%' : '70%'}><PriceCalculationForm
              measurementUnit={formValues.partData && formValues.partData[activeTab].measurementUnit}
              activeTab={activeTab}
              formValues={formValues}
              setFormValues={setFormValues}
              disabled={disabled}
              setDisabled={setDisabled}
            /></Div>
          }
          {
            !isMobileXL && <Div flexBasis='30%'>
              <Summary
                formValues={formValues}
                activeTab={activeTab}
                onChangeTab={onChangeTab}
                sticky={true}
                isNotTop={false}
                ContentRef={ContentRef}
                isOne={data.packageParts && data.packageParts.length === 1}
              />
            </Div>
          }
        </Div>
      </TabPart>
    </ContentParts>
  </FullWidthContainer>
)


export default Parts



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/components/parts/index.jsx